<template lang="pug">
  LoginComponent
    form(role="form" @submit.prevent="recoverPassword()")
      .field(v-show='!passwordResetRequestSent')
        i.fa.fa-info-circle
        |  If you have forgotten your password, you can request a reset
        |  by entering your username below.
      .field(v-show='!passwordResetRequestSent')
        input.prusername(type='text' v-model='username' placeholder='Enter username', required='' style="max-width: 200px;")
        SspActionButton(type="submit" :disabled='!username' text="Reset password" )
    .field(v-show='!passwordResetRequestSent')
      a.btn.btn-link-cancel.pull-right(type="button" href='#/security/login') Cancel
    .field(v-show='passwordResetRequestSent')
      div
        i.fa.fa-info-circle
        |  If you filled out a valid username, you should receive an
        |  e-mail message shortly giving you further instructions on how to complete your password
        |  reset.
    p.field(v-show='passwordResetRequestSent')
      button.btn.btn-primary.pull-right(type="button" @click="backToLogin()") Back to log-in page

</template>

<script>
import LoginComponent from '@/components/ssp/LoginComponent'
import Security from '@/service/apis/Security'

export default {
  mounted() {
    this.$el.querySelector('.prusername').focus()
  },
  data: () => ({
    recovering: false,
    username: null,
    passwordResetRequestSent: false
  }),
  methods: {
    recoverPassword() {
      this.recovering = true
      return Security.requestPasswordReset(this.username)
        .then(() => {
          this.passwordResetRequestSent = true
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.recovering = false
        })
    },
    backToLogin() {
      this.$router.push('/security/login')
    }
  },
  components: {
    LoginComponent
  }
}
</script>

<style lang="scss">
.prusername {
  height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/security/RecoverPassword.vue